import { Column, Row, Box, GridContainer, H2 } from '@vp/swan'
import CallMe from './components/callMe/CallMe'
import LiveChat from './components/chat/LiveChat'
import Email from './components/email/Email'
import Phone from './components/phone/Phone'
// import { WhatsAppContent, WhatsAppHeader, WhatsAppFooter } from '@vp/contact-channels'
import { WhatsApp } from '@vp/contact-channels'
import { useTranslation } from 'react-i18next'
import { HC_CONFIG } from './modules/localization/config'
import LegacyLiveChat from './components/legacy-chat/LegacyLiveChat'
import chatHelper from './helpers/chatHelper'
import { initCA } from '@vp/chat-anywhere'
import { useEffect, useState } from 'react'
import styles, { stylesheet } from './App.scss'
import { useStyles } from '@vp/ubik-context'
import { isTreatmentEnabled } from '@vp/ctc-reader'
import { initialize, waitTillAvailable, activate } from '@vp/ab-reader'
import { getExperimentByLocale, isExperimentAvailable, shouldShowExp } from './modules/experiment'
import AnalyticsTracking from '../src/components/analytics/analytics'

interface Props {
  locale: string
  tenant: string
  trackingTenant: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contactChannels: any
  segmentKey: string
}
export const App = (props: Props) => {
  const { tenant, locale, contactChannels, segmentKey, trackingTenant } = props
  const [proadvantageType, setProadvantageType] = useState('')
  const [loadingProAdvantage, setLoadingProAdvantage] = useState(true)
  const { t } = useTranslation(tenant)

  useStyles(stylesheet)

  const isProadvantage = proadvantageType !== ''
  const lng = locale.toLowerCase().replace('-', '_')
  const chatProAdvantageLocales = 'CHAT_PROADVANTAGE_LOCALES'.split(',')
  const config = HC_CONFIG[locale.toLowerCase()]?.contactUsComponents || []
  const [loadingExperiment, setLoadingExperiment] = useState(true)
  const [experimentEnabled, setExperimentEnabled] = useState(false)

  useEffect(() => {
    initialize()
    checkExperiment()
    if (chatHelper.isCAEnabled(locale)) initCA()
  }, [locale])

  useEffect(() => {
    setLoadingProAdvantage(true)
    if (HC_CONFIG[locale.toLowerCase()]?.proadvantageProgram) {
      if (typeof window !== 'undefined' && window.document) {
        if (isTreatmentEnabled('proadvantage_basic_care')) {
          setProadvantageType('basic')
        } else if (isTreatmentEnabled('proadvantage_premium_care')) {
          setProadvantageType('premium')
        }
      }
    }
    setLoadingProAdvantage(false)
  }, [])

  const checkExperiment = async () => {
    setLoadingExperiment(true)
    if (!isExperimentAvailable(locale)) {
      setLoadingExperiment(false)
      setExperimentEnabled(false)
      return
    }
    await waitTillAvailable(1000)
    const variation = activate(getExperimentByLocale(locale))
    setExperimentEnabled(shouldShowExp(variation))
    setLoadingExperiment(false)
  }

  const handleClick = () => {
    if (experimentEnabled) {
      AnalyticsTracking.trackEventWithDetails('Experiment Clicked', {
        label: 'Help Center view',
        eventDetail: '/customer-care/help-centre/;pop_up;contact_cards;Chat On WhatsApp',
        navigationDetail: 'Chat On WhatsApp',
        pageSection: 'Help Center',
        pageStage: 'Customer Care',
        pageName: 'Home Page:Help Center',
        trackingTenant: 'vistaprint',
        experimentName: 'hc_whatsapp_experiment_uk_de',
        variationName: 'test',
        experimentDetail: 'expo_2789_whatsapp_chat_initiated',
      })
    }
  }
  return (
    <GridContainer>
      <Column span={12} id="contactUsContainer">
        <Row mb="6">
          <H2 display="flex">{t(`${tenant}:page.body.title`, { lng })}</H2>
        </Row>
        <Row className={styles.contactUsV2Container}>
          {config.includes('phone_v2') && (isProadvantage || !config.includes('call_me_v2')) ? (
            <Box className={styles.contactUsBox}>
              <Phone tenant={tenant} locale={locale} contactChannels={contactChannels} proadvantageType={proadvantageType} />
            </Box>
          ) : null}
          {config.includes('call_me_v2') && !isProadvantage ? (
            <Box className={styles.contactUsBox}>
              <CallMe
                tenant={tenant}
                locale={locale}
                segment="Regular"
                contactChannels={contactChannels}
                fallBack={
                  config.includes('phone_v2') ? (
                    <Phone tenant={tenant} locale={locale} contactChannels={contactChannels} proadvantageType={proadvantageType} />
                  ) : null
                }
              />
            </Box>
          ) : null}
          {config.includes('live_chat_v2') && !isProadvantage && !loadingProAdvantage ? (
            <Box className={styles.contactUsBox}>
              <LiveChat tenant={tenant} locale={locale} contactChannels={contactChannels} trackingTenant={trackingTenant} segmentKey={segmentKey} />
            </Box>
          ) : null}
          {config.includes('live_chat_v2') && isProadvantage && chatProAdvantageLocales.includes(locale.toLowerCase()) && !loadingProAdvantage ? (
            <Box className={styles.contactUsBox}>
              <LegacyLiveChat
                tenant={tenant}
                locale={locale}
                contactChannels={contactChannels}
                trackingTenant={trackingTenant}
                segmentKey={segmentKey}
                isProadvantage={isProadvantage}
              />
            </Box>
          ) : null}
          {config.includes('whatsapp') && experimentEnabled && !loadingExperiment ? (
            <WhatsApp onClick={handleClick} variation="standard" cardOverrides={{ p: '6', style: { flex: 1 } }} />
          ) : null}

          {config.includes('email_v2') ? (
            <Box className={styles.contactUsBox}>
              <Email
                tenant={tenant}
                locale={locale}
                contactChannels={contactChannels}
                proadvantageType={proadvantageType}
                isCallMeEnabled={config.includes('call_me_v2')}
              />
            </Box>
          ) : null}
        </Row>
      </Column>
    </GridContainer>
  )
}
